module.exports = __webpack_public_path__ + "img/generic-icon.c7f5ff01.svg";